import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';
import './style/mobile-carousel.css.scss'

interface IMobileCarouselProps {
  chunkedData: any[],
  children:JSX.Element[]
};
export const MobileCarousel = ({ chunkedData,children }: IMobileCarouselProps) => {

  const settings = {
    className: 'slider variable-width mt-11',
    centerMode: false,
    focusOnSelect: true,
    infinite: false,
    centerPadding: '5em',
    slidesToShow: 1,
    speed: 500,
    variableWidth: true,
    dots: true,
    arrows:false,
    appendDots: (dots: any) => (
      <div

        style={{
          display:'flex',
          justifyItems:'flex-start'
        }}
      >
        <ul  className={'mt-5'} style={{paddingLeft:'unset'}}> {dots} </ul>
      </div>
    ),
    customPaging: (i: number) => (
      <div
        className={'custom-dot'}
      >
      </div>
    ),
  };

  return <>
    <Slider {...settings}>
      {children}
    </Slider>
  </>;
};
